import { products } from '../data/milestones'

const navItems = [
  { key: 'all', label: 'الكل', icon: '◈' },
  { key: 'rafiq', label: 'رفيق', icon: '🚗' },
  { key: 'muwafaq', label: 'موافق', icon: '✅' },
  { key: 'sahha', label: 'صحة', icon: '🏥' },
  { key: 'more', label: 'المزيد', icon: '⋯' },
]

export default function MobileNav({ activeProduct, onNavigate }) {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-void/90 backdrop-blur-md border-t border-white/[0.06] flex items-center justify-around py-2 mobile-nav-safe lg:hidden">
      {navItems.map(item => {
        const isActive = activeProduct === item.key
        const prodConfig = item.key !== 'all' && item.key !== 'more' ? products[item.key] : null

        return (
          <button
            key={item.key}
            onClick={() => onNavigate(item.key)}
            className={`
              flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg transition-all duration-150 min-w-[44px]
              ${isActive && prodConfig ? 'text-[' + prodConfig.primary + ']' : isActive ? 'text-[#8B5CF6]' : 'text-[#64748B]'}
            `}
            style={isActive && prodConfig ? { color: prodConfig.primary } : {}}
          >
            <span className="text-lg">{item.icon}</span>
            <span className="text-[10px] font-medium">{item.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
